import { useThemeStore } from '@/stores/themeStore';
import { useEffect } from 'react';

export const useTheme = () => {
  const { theme, actualTheme, setTheme, cycleTheme, getSystemTheme } = useThemeStore();

  // Escutar mudanças na preferência do sistema
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    
    const handleChange = () => {
      if (theme === 'system') {
        // Forçar re-render quando a preferência do sistema mudar
        useThemeStore.setState({ actualTheme: getSystemTheme() });
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme, getSystemTheme]);

  return {
    theme,
    actualTheme,
    setTheme,
    cycleTheme,
    getSystemTheme,
    isDark: actualTheme === 'dark',
    isLight: actualTheme === 'light',
    isSystem: theme === 'system',
  };
};
